module.exports = __webpack_public_path__ + "static/media/logo.67377e16.png";